var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("td", { staticClass: "td-status" }, [
    _c("div", { staticClass: "dropdown" }, [
      _vm.order.status != 1
        ? _c(
            "a",
            {
              class: "oc-status-" + _vm.order.status,
              attrs: {
                href: "#",
                type: "button",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false"
              }
            },
            [_vm._v(_vm._s(_vm.order.view.status_name))]
          )
        : _c(
            "a",
            {
              class: "oc-status-" + _vm.order.status,
              attrs: { href: "#", disabled: "" }
            },
            [_vm._v(_vm._s(_vm.order.view.status_name))]
          ),
      _vm._v(" "),
      _vm.order.status != 1
        ? _c(
            "ul",
            { staticClass: "dropdown-menu" },
            _vm._l(_vm.statusName, function(status, index) {
              return index &&
                _vm.order.status != index &&
                +_vm.statusEnable[index]
                ? _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        class: "control oc-status-" + index,
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            return _vm.setStatus(index)
                          }
                        }
                      },
                      [_vm._v(_vm._s(status))]
                    )
                  ])
                : _vm._e()
            }),
            0
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68787b16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68787b16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/backend/components/table/fields/StatusField.vue
// module id = 172
// module chunks = 1